import ProductFilter from "../components/product-filter";

export default {
    init() {
        var filter = new ProductFilter('.products:not(.products-editing)');
    },
    finalize() {
        jQuery('.back-to-list-top').click(function(event){
            event.preventDefault();
            jQuery('html, body').animate({
                scrollTop: jQuery("#products-list").offset().top - 1
            }, 500);
            jQuery('html, body').animate({ // go down 1px to hide floaty header (bit of a hack)
                scrollTop: jQuery("#products-list").offset().top
            }, 1);
        });

        jQuery('body').on('click', 'a[href*="#"].button', function(event){
            const href = jQuery(this).attr('href');
            const hash = href.substring(href.indexOf('#'));

            if ( jQuery(hash).length === 0 ) {
                return;
            }

            event.preventDefault();

            jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top - 50
            }, 500);
        });

        const buy_your_pack_sticky = () => {

            const products_editing = jQuery('.products__editing');
            if ( products_editing.length ) {

                const products_editing_items = jQuery('.products__editing-items');
                const buy_this_pack_el = jQuery('.buy-this-pack-sticky');
                if ( products_editing_items.length && buy_this_pack_el.length ) {
                    const current_scroll = jQuery(window).scrollTop();
                    const products_editing_items_offset = products_editing_items.offset().top - 200;

                    if ( current_scroll > products_editing_items_offset ) {
                        buy_this_pack_el.addClass('fixed');
                    } else {
                        buy_this_pack_el.removeClass('fixed');
                    }
                }

                jQuery(window).scroll(() => {
                    const products_editing_items = jQuery('.products__editing-items');
                    const buy_this_pack_el = jQuery('.buy-this-pack-sticky');
                    if ( products_editing_items.length && buy_this_pack_el.length ) {
                        const current_scroll = jQuery(window).scrollTop();
                        const products_editing_items_offset = products_editing_items.offset().top - 200;
    
                        if ( current_scroll > products_editing_items_offset ) {
                            buy_this_pack_el.addClass('fixed');
                        } else {
                            buy_this_pack_el.removeClass('fixed');
                        }
                    }
                });
            }

        };

        buy_your_pack_sticky();
        jQuery(window).resize(() => {
            buy_your_pack_sticky();
        });

        jQuery( document.body ).on( 'wc_fragments_refreshed', function(){
            buy_your_pack_sticky();
        });

        load_from_consultation_handler();
       
        jQuery( document.body ).on( 'wc_fragments_refreshed', function(){
            const product_descriptions = jQuery('.product__shortdescription');
            if ( product_descriptions.length ) {
                for ( const el of product_descriptions ) {
                    const product_description = jQuery(el);

                    product_description.removeClass('has-more-button show-all');
                    if ( product_description.find('.show').length ) {
                        product_description.find('.show').remove();
                    }
                    

                    if ( product_description.innerHeight() > 54 ) {
                        product_description.addClass('has-more-button');
                        product_description.append('<span class="show">... <span class="text">Read more</span></span>');
                    }
                }
            }

        });  
        
        jQuery(window).resize(() => {
            const product_descriptions = jQuery('.product__shortdescription');
            if ( product_descriptions.length ) {
                for ( const el of product_descriptions ) {
                    const product_description = jQuery(el);

                    product_description.removeClass('has-more-button show-all');
                    if ( product_description.find('.show').length ) {
                        product_description.find('.show').remove();
                    }
                    
                    if ( product_description.innerHeight() > 54 ) {
                        product_description.addClass('has-more-button');
                        product_description.append('<span class="show">... <span class="text">Read more</span></span>');
                    }
                }
            }                
        });

        jQuery( document.body ).on( 'click', '.product__shortdescription .show', function(){
            jQuery(this).parent().addClass('show-all');
        });
    }
};

/** Set the cart hash in both session and local storage */
const set_cart_hash = (cart_hash, cart_hash_key, $supports_html5_storage) =>  {
    if ( $supports_html5_storage ) {
        localStorage.setItem( cart_hash_key, cart_hash );
        sessionStorage.setItem( cart_hash_key, cart_hash );
    }
}

const set_cart_creation_timestamp = ($supports_html5_storage) => {
    if ( $supports_html5_storage ) {
        sessionStorage.setItem( 'wc_cart_created', ( new Date() ).getTime() );
    }
}

const load_from_consultation_handler = () => {
    if ( typeof wc_cart_fragments_params === 'undefined' ) {
        return;
    }

    /* Storage Handling */
    var $supports_html5_storage = true,
        cart_hash_key           = wc_cart_fragments_params.cart_hash_key;

    try {
        $supports_html5_storage = ( 'sessionStorage' in window && window.sessionStorage !== null );
        window.sessionStorage.setItem( 'wc', 'test' );
        window.sessionStorage.removeItem( 'wc' );
        window.localStorage.setItem( 'wc', 'test' );
        window.localStorage.removeItem( 'wc' );
    } catch( err ) {
        $supports_html5_storage = false;
    }


    var $fragment_refresh = {
        url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
        type: 'POST',
        data: {
            time: new Date().getTime()
        },
        timeout: wc_cart_fragments_params.request_timeout,
        success: function( data ) {
            if ( data && data.fragments ) {

                jQuery.each( data.fragments, function( key, value ) {
                    jQuery( key ).replaceWith( value );
                });

                if ( $supports_html5_storage ) {
                    sessionStorage.setItem( wc_cart_fragments_params.fragment_name, JSON.stringify( data.fragments ) );
                    set_cart_hash( data.cart_hash, cart_hash_key, $supports_html5_storage );

                    if ( data.cart_hash ) {
                        set_cart_creation_timestamp( $supports_html5_storage );
                    }
                }

                jQuery( document.body ).trigger( 'wc_fragments_refreshed' );
            }
        },
        error: function() {
            jQuery( document.body ).trigger( 'wc_fragments_ajax_error' );
        }
    };

    jQuery( document.body ).on( 'wc_fragments_refreshed', function(){
        let loaded_consultation_event = new CustomEvent("ew-loaded-consultation");
        document.dispatchEvent(loaded_consultation_event);      
    });

    setTimeout(function(){
        if ( typeof window.on_load_consultation_id !== 'undefined' ) {

            let loading_consultation_event = new CustomEvent("ew-loading-consultation");
            document.dispatchEvent(loading_consultation_event);
    
            jQuery.ajax({
                type: "POST",
                url: window.toCartUrl,
                data: { consultation_id: window.on_load_consultation_id }
            })
            .done(function (product_ids) {
                if ( product_ids.length ) {
                    jQuery('.products__group .product').removeClass('recommended');
                    for ( const product_id of product_ids ) {
                        jQuery('.products__group .product.post-' + product_id).addClass('recommended');
                    }
                }

                jQuery.ajax( $fragment_refresh );
            });        
        }
    });

    jQuery('body').on('click', '.load-from-consultation', function(e){
        const button = jQuery(this);
        const consultation_id = button.data('consultation_id');

        button.addClass('loading');

        let loading_consultation_event = new CustomEvent("ew-loading-consultation");
        document.dispatchEvent(loading_consultation_event);

        jQuery.ajax({
            type: "POST",
            url: window.toCartUrl,
            data: { consultation_id: consultation_id }
        })
        .done(function (response) {
            jQuery.ajax( $fragment_refresh );
            button.removeClass('loading');       
        });

    });

};



// WEBPACK FOOTER //
// ./js/routes/post-type-archive-product.js